<template>
  <el-dialog
    title="发放"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    @close="handleClose"
    custom-class="grant-dialog"
  >
    <el-form :model="form" label-width="150px" ref="grantForm">
      <el-form-item
        label="请输入用户手机号"
        prop="phone"
        :rules="[
          { required: true, message: '请输入用户手机号', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
        ]"
      >
        <div class="input-container">
          <div class="input-wrapper">
            <el-input v-model="form.phone" placeholder="请输入"></el-input>
          </div>
          <!-- <el-button type="primary" @click="checkUserInfo" class="check-btn"
            >查看用户信息</el-button
          > -->
        </div>
      </el-form-item>
      <el-form-item label="付款类型" prop="payType" :rules="{ required: true, message: '请选择付款类型', trigger: 'change' }">
         <el-radio-group v-model="form.payType" >
          <el-radio  label="1" key="1">
            线上付款发放 
          </el-radio>
          <el-radio  label="0" key="0">
            线下付款发放
          </el-radio>
         </el-radio-group>
         
      </el-form-item>
      <el-form-item label="备注">
        <div class="input-wrapper">
          <el-input
            type="textarea"
            v-model="form.remark"
            placeholder="请输入线下打款信息等"
            :rows="4"
          ></el-input>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { certificationByPhone } from "@/api/package";

export default {
  name: "GrantDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    grantForm: {
      type: Object,
      default: () => ({
        phone: "",
        remark: "",
        payType: '1',
      }),
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  data() {
    return {
      form: {
        phone: "",
        remark: "",
        payType: '1',
      },
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.form = { ...this.grantForm };
      }
    },
  },
  methods: {
    handleClose() {
      this.$refs.grantForm?.resetFields();
      // this.$emit("update:visible", false);
      // this.$emit("close");
      this.dialogVisible = false;
      this.$emit("close");
    },
    handleSubmit() {
      this.$refs.grantForm.validate((valid) => {
        if (valid) {
          this.$emit("grant", this.form);
        }
      });
    },
    async checkUserInfo() {
      if (!this.form.phone) {
        this.$message.warning("请先输入手机号");
        return;
      }

      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }

      try {
        const { data } = await this.$ajax.get(
          certificationByPhone(this.form.phone)
        );
        if (data?.code === 200) {
          console.log(data.data);
          if (data.data.state !== "CERTIFIED") {
            this.$message.warning("该用户未进行身份认证或认证未通过");
            return;
          }
          sessionStorage.setItem("currentUserInfo", JSON.stringify(data.data));
          //   this.$router.push(`/users/${data.data.id}/${data.data.userId}`);
        } else {
          this.$message.warning(data?.msg || "该用户未注册");
        }
      } catch (error) {
        this.$message.error("查询用户信息失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.grant-dialog {
  :deep(.el-dialog__body) {
    padding: 20px;
  }

  :deep(.el-dialog__header) {
    padding: 15px 20px;
    border-bottom: 1px solid #ebeef5;
  }

  :deep(.el-dialog__footer) {
    border-top: 1px solid #ebeef5;
    padding: 15px 20px;
    text-align: center;
  }

  :deep(.el-form-item__label) {
    font-weight: normal;
    line-height: 32px;
  }

  .input-wrapper {
    width: 320px;
  }

  .input-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .check-btn {
    white-space: nowrap;
    background-color: #409eff;
    border-color: #409eff;
    color: white;
  }

  :deep(.el-textarea__inner) {
    min-height: 100px !important;
  }

  :deep(.el-form-item:last-child) {
    margin-bottom: 0;
  }
}

.dialog-footer {
  .el-button {
    min-width: 80px;
  }
}
</style>
